<template>
  <v-card v-if="user" flat>
    <v-card-title subtitle-2>{{getPlayersCount()}}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="players"
        :search="search"
        item-key="hash"
        class="elevation-1"
        :loading="players.length<=0 && !timeoutPlayers"
        loading-text="Loading... Please wait"
      >
        <template slot="item" slot-scope="items">
          <tr>
            <td>{{ items.item.hash }}</td>
            <td>{{ items.item.name }}</td>
            <td
              :class="items.item.status.online ? 'green--text' : 'red--text'"
            >{{ items.item.status.online ? lang.online : lang.offline }}</td>
            <td>{{ formatDate(items.item.status.last_seen) }}</td>
            <td>{{formatDate(items.item.registered_at)}}</td>
            <td>{{ items.item.device.softwareVer}}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
        <template v-slot:no-data>{{lang.no_displays}}</template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
const utils = require("@/classes/utils/utils.js").Utils;

export default {
  data() {
    return {
      search: "",
      headers: [],
      timeoutPlayers: false
    };
  },
  computed: {
    ...mapState(["lang", "adminUser"])
  },
  props: {
    user: {
      default: false
    },
    players: {
      default: false
    }
  },
  methods: {
    formatDate(date) {
      return utils.formatDate(date);
    },
    getPlayersCount() {
      if (this.players != null && this.players.length > 1) {
        return (
          this.lang.registered_players +
          " (1 Free + " +
          (this.players.length-1) +
          ")"
        );
      } else if(this.players.length == 1){
        return this.lang.registered_players + " (1 Free)";
      }
      else{
         return this.lang.registered_players + " (0)";
      }
    },
    endTimeout() {
      this.timeoutPlayers = true;
    }
  },
  mounted() {
    this.timeout = false;
    this.headers = [
      { text: this.lang.hash, value: "hash" },
      { text: this.lang.device, value: "name" },
      { text: this.lang.status, value: "status" },
      { text: this.lang.last_seen, value: "last_seen" },
      { text: this.lang.date_added, value: "registered_at" },
      { text: this.lang.software, value: "" }
    ];
    setTimeout(this.endTimeout, 5000);
  }
};
</script>